import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PlusMinus from "../Components/PlusMinus";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import { postJson } from "../Utils/apiUtils";
import AlarmSimpleOk from "./AlarmSimpleOk";

const AddGifticonBox = ({ handleClickX, handleApply, selectedInfo }) => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const offset = 10;

  const [gifticon_list, setGifticon_list] = useState([]);

  const [selectedItem, setSelectedItem] = useState(
    selectedInfo ? selectedInfo : {}
  );

  const [alarmState, setAlarmState] = useState({ show: false, type: "" });

  const getGifticonList = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/getGifticonList",
        { page, offset },
        navigate
      );

      if (res.code === 200) {
        setGifticon_list(res.data.rows);
      }
    } catch (error) {
      console.error("보유 기프티콘 리스트 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    getGifticonList();
    setSelectedItem(selectedInfo);
  }, []);

  useEffect(() => {
    if (selectedItem?.orderItemId && selectedItem?.quantity > 0) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  }, [selectedItem]);

  return (
    <Box>
      {alarmState.show && (
        <AlarmSimpleOk
          title="기프티콘 등록 불가"
          description={
            <>
              상품 수량을 확인해주세요.
              <br /> 발급 가능한 갯수만 등록 가능합니다.
            </>
          }
          handleClickX={() => setAlarmState({ show: false, type: "" })}
        />
      )}
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          기프티콘 등록
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>
      <p style={{ marginTop: "10px", textAlign: "center" }}>
        챌린지 달성 시 제공할 기프티콘을 선택하고 갯수를 설정해주세요. <br />
        등록 가능한 갯수 만큼만 등록할 수 있습니다.
      </p>

      {gifticon_list.length != 0 ? (
        <div
          className="scrollView"
          style={{ marginTop: "20px", width: "537px", height: "512px" }}
        >
          {gifticon_list.map((data) => (
            <GifticonItem
              key={data.orderItemId}
              orderItemId={data.orderItemId}
              goodsImgS={data.goodsImgS}
              brandName={data.brandName}
              goodsName={data.goodsName}
              availableCount={data.availableCount}
              goodsStateCd={data.goodsStateCd}
              orderItemRefundId={data.orderItemRefundId}
              setSelectedItem={setSelectedItem}
              selectedItem={selectedItem}
            />
          ))}
        </div>
      ) : (
        <div
          className="center"
          style={{
            marginTop: "20px",
            width: "537px",
            height: "450px",
            borderRadius: "20px",
            backgroundColor: "#f5f5f5",
          }}
        >
          <p className="medium-text" style={{ color: "#888888" }}>
            보관함에 기프티콘이 없습니다.
          </p>
        </div>
      )}

      <div
        className="blueBtn-base"
        style={{
          marginTop: "30px",
          height: "60px",
          borderRadius: "10px",
          backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
        }}
        onClick={() => {
          if (selectedItem.quantity > selectedItem.availableCount) {
            setAlarmState({ show: true, type: "availableCount error" });
          } else if (selectedItem.quantity <= 0) {
          } else {
            handleApply({
              orderItemId: selectedItem.orderItemId,
              brandName: selectedItem.brandName,
              goodsImgS: selectedItem.goodsImgS,
              goodsName: selectedItem.goodsName,
              availableCount: selectedItem.availableCount,
              quantity: selectedItem.quantity,
            });
            handleClickX();
          }
        }}
      >
        등록
      </div>
    </Box>
  );
};

const GifticonItem = ({
  orderItemId,
  goodsImgS,
  brandName,
  goodsName,
  availableCount,
  goodsStateCd,
  orderItemRefundId,
  selectedItem,
  setSelectedItem,
}) => {
  const [quantity, setQuantity] = useState(
    selectedItem?.orderItemId === orderItemId ? selectedItem?.quantity : 0
  );

  useEffect(() => {
    setQuantity(
      selectedItem?.orderItemId === orderItemId ? selectedItem?.quantity : 0
    );
  }, []);

  useEffect(() => {
    if (selectedItem?.orderItemId === orderItemId) {
      setSelectedItem((prev) => ({
        ...prev,
        quantity,
      }));
    }
  }, [quantity]);

  return (
    <div
      style={{
        borderRadius: "20px",
        padding: "20px",
        backgroundColor: "#f5f5f5",
        marginBottom: "14px",
        position: "relative",
        cursor: goodsStateCd === "SUS" ? "" : "pointer",
        boxShadow:
          selectedItem?.orderItemId === orderItemId
            ? "inset 0 0 0 2px #1167ed"
            : "",
      }}
      onClick={
        goodsStateCd === "SUS" || orderItemRefundId
          ? null
          : () =>
              setSelectedItem({
                ...selectedItem,
                orderItemId,
                brandName,
                goodsImgS,
                goodsName,
                quantity,
                availableCount,
              })
      }
    >
      {goodsStateCd === "SUS" || orderItemRefundId ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            margin: "-20px 0 0 -20px",
            backgroundColor: "rgba(0,0,0,0.1)",
            position: "absolute",
            borderRadius: "20px",
          }}
        />
      ) : (
        ""
      )}
      <div className="hrz-wrapper">
        <div
          style={{
            backgroundColor: "#d9d9d9",
            width: "81px",
            height: "80px",
            borderRadius: "10px",
          }}
        >
          <img
            src={goodsImgS}
            style={{ width: "100%", height: "100%", borderRadius: "10px" }}
          />
        </div>
        <div style={{ marginLeft: "16px" }}>
          <p
            className="bold-text"
            style={{
              fontSize: "14px",
              color:
                goodsStateCd === "SUS" || orderItemRefundId ? "#888888" : "",
            }}
          >
            {brandName}
          </p>
          <p
            className="medium-text"
            style={{
              color:
                goodsStateCd === "SUS" || orderItemRefundId ? "#888888" : "",
            }}
          >
            {goodsName}
          </p>
          <p
            className="bold-text"
            style={{
              marginTop: "2px",
              color:
                goodsStateCd === "SUS" || orderItemRefundId ? "#888888" : "",
            }}
          >
            {availableCount?.toLocaleString()}개 보유
          </p>
        </div>

        <div style={{ marginLeft: "auto" }}>
          {orderItemRefundId && (
            <p
              className="medium-text"
              style={{ fontSize: "14px", color: "#6d6d6d" }}
            >
              환불처리중
            </p>
          )}
          {goodsStateCd === "SUS" && (
            <div
              className="center"
              style={{
                width: "72px",
                height: "36px",
                borderRadius: "8px",
                backgroundColor: "#fde7e7",
                color: "#f25c5c",
                fontSize: "14px",
                fontFamily: "notoSans-medium",
                position: "absolute",
                marginTop: "-20px",
                marginLeft: "-70px",
                zIndex: 3,
              }}
            >
              판매중지
            </div>
          )}
        </div>
      </div>
      {goodsStateCd === "SALE" && (
        <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
          <div style={{ marginLeft: "auto" }}>
            <PlusMinus
              value={quantity}
              setValue={(value) => {
                setQuantity(value);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

const AddGifticon = ({ handleClickX, handleApply, selectedInfo }) => {
  return (
    <LayoutModal
      Modal={
        <AddGifticonBox
          handleClickX={handleClickX}
          handleApply={handleApply}
          selectedInfo={selectedInfo}
        />
      }
    />
  );
};

export default AddGifticon;
